import AboutCeliora from "../components/AboutCeliora";

import BannerSection from "../components/BannerSection";
import FAQSection from "../components/FAQSection";
import FeaturedCollection from "../components/FeaturedCollection";

import Hero from "../components/Hero";

import Testimonials from "../components/Testimonials";
import WhyCeliora from "../components/WhyCeliora";


const Home = () => {
  return (
    <>
     
      <Hero />
      <AboutCeliora />
      <FeaturedCollection />
      <BannerSection />
      <WhyCeliora />
      <Testimonials />
      <FAQSection />
      
      
    </>
  );
};

export default Home;